class ChiliPiperBannerController {
  constructor(Authentication, $rootScope, $window) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      $rootScope,
      $window,
    });
  }

  onUpdateClientFlags = (clientFlags) => {
    this.$rootScope.$emit('sdk:client-flags:save', clientFlags);
  };

  get path() {
    return this.$window.location.pathname;
  }
}

export default {
  template: `
    <r-chili-piper-banner
      path="ctrl.path"
      current-user="ctrl.Authentication.user"
      on-update-client-flags="ctrl.onUpdateClientFlags(clientFlags)">
    </r-onboarding-checklist-guard>
    `,
  controller: ChiliPiperBannerController,
  controllerAs: 'ctrl',
};
